module.exports = __webpack_public_path__ + "static/media/BoyHairShort.c5b9932e.svg";